import "core-js/modules/es.error.cause.js";
import { addConsignee } from './../request';
import { isPhone } from '@/utils/validate';
export default {
  data() {
    return {
      // logisticsSelectList,
      mailingInfo: {
        name: undefined
      },
      previewVisible: false
    };
  },
  computed: {
    dataRule() {
      return {
        mobile: [{
          required: true,
          trigger: 'blur',
          validator: this.validatMobile
        }],
        address: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('具体地址')
        }],
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('收件人')
        }]
      };
    }
  },
  methods: {
    validatMobile(rule, value, callback) {
      if (!isPhone(value)) {
        callback(new Error(this.$t('手机号码有误，请重新填写')));
      } else {
        callback();
      }
    },
    init(id) {
      // this.mailingInfo.id=id;
      this.previewVisible = true;
    },
    handleSure() {
      this.$refs.from.validate(valid => {
        if (valid) {
          addConsignee(this.mailingInfo).then(res => {
            this.$message.success(this.$t('添加成功'));
            this.$emit('ok', res);
            this.$emit('cancel');
          });
        }
      });
    }
  }
};